(() => {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const REVEAL_SELECTOR = [
    '.shopify-section--flavor-showcase',
    '.shopify-section--nutrition',
    '.shopify-section--differentiator',
    '.shopify-section--story',
    '.shopify-section--how-it-works',
    '.shopify-section--reviews',
    '.shopify-section--trust-icons',
    '.shopify-section--faq',
    '.shopify-section--instagram',
    '.shopify-section--newsletter',
    '.shopify-section--lockup',
    '.shopify-section--featured-in',
  ].join(',');

  const sections = document.querySelectorAll(REVEAL_SELECTOR);
  if (!sections.length) return;

  sections.forEach((el) => el.classList.add('is-reveal'));

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  sections.forEach((el) => io.observe(el));
})();
